import React from "react";
import { useParams } from "react-router-dom";
import NavBar from "../../components/Navbar";
import { useSelector } from "react-redux";
import GetPosterUrl from "../../components/PosterUrl";

function ShowDetails() {

    const itemId = useParams();
    
    const bothShows = useSelector((state) => state.allData.shows); 

    const found = bothShows?.map((element) =>  {
        // console.log(element)
        if(element.id == itemId.movieId){
            console.log(element);
            return element;
        }
    });
    const [selectedItem] = found.filter(function(item) {
        return item !== undefined;
    });

    console.log("res ",(selectedItem.id));

    return (
        <>
            <NavBar />
            
            <section className="text-gray-700 overflow-hidden">
                <div className="container px-5 py-24 mx-auto flex">
                    <div className="flex-col">
                    <h1 className="text-gray-900 text-3xl font-bold mb-1 pb-6">{ selectedItem?.name || selectedItem?.title }</h1>
                    
                    <img className="max-w-full h-auto rounded-lg" src={GetPosterUrl(selectedItem?.poster_path)} />

                    </div>

                    <div className="flex-col pt-[100px] pl-10">
                        <h3 className="font-bold text-3xl">About</h3>
                        <p className="pt-4 pl-3 font-semibold text-xl">{selectedItem?.overview}</p>

                        <h3 className="font-bold text-3xl pt-2 text-blue-700">Release Date</h3>
                        <p className="pt-4 pl-3 font-semibold text-xl">{selectedItem?.release_date || selectedItem?.first_air_date }</p>

                        <h3 className="font-bold text-3xl pt-2 text-red-500">Popularity</h3>
                        <p className="pt-4 pl-3 font-semibold text-xl text-sky-600">{selectedItem?.popularity}</p>
                </div>
                </div>
                
            </section>
        </>
    );
}

export default ShowDetails;
